import { BackButton, CloseButton } from 'components/common/Button/Button';
import Checkbox from '../../Checkbox/Checkbox';
import classes from './MobileSubOptionsFilter.module.css';
import { Option } from 'utils/interfaces/commonInterfacesAndTypes';
import { SUB_OPTIONS_FILTER_LABELS } from 'constants/mobileSubOptionsFilterLabels';
import useTranslation from 'next-translate/useTranslation';

type MobileSubOptionsFilter = {
   mainOption: Option;
   subOptions: Option[];
   selectedSubOptions: { [key: string]: string[] };
   onChangeSubOptionHandler: (mainOption: string, value: string) => void;
   onClickBackHandler: () => void;
   onCloseMenuHandler?: () => void;
};

const MobileSubOptionsFilter = ({
   mainOption,
   subOptions,
   selectedSubOptions,
   onChangeSubOptionHandler,
   onClickBackHandler,
   onCloseMenuHandler,
}: MobileSubOptionsFilter) => {
   const { t } = useTranslation('common');

   const selectedSubOptionsCounter =
      selectedSubOptions[mainOption.value] && selectedSubOptions[mainOption.value].length
         ? ` (${selectedSubOptions[mainOption.value].length})`
         : '';

   return (
      <div className={classes.mobileSubOptionsFilter}>
         <div className={classes.filterHeading}>
            <BackButton onClick={onClickBackHandler} />
            <span>
               <span className={classes.mainCategoryText}>
                  {t(mainOption.label) + selectedSubOptionsCounter}
               </span>
            </span>
            <CloseButton onClick={onCloseMenuHandler} />
         </div>
         <div className={classes.menuContent}>
            <div className={classes.descriptionText}>
               {t(SUB_OPTIONS_FILTER_LABELS[mainOption.value])}
            </div>
            <ul>
               {subOptions.map(subOption => (
                  <li
                     onClick={() => onChangeSubOptionHandler(mainOption.value, subOption.value)}
                     className={classes.option}
                     key={subOption.value}
                  >
                     <Checkbox
                        id={subOption.value}
                        label={subOption.label}
                        value={
                           selectedSubOptions[mainOption.value]
                              ? selectedSubOptions[mainOption.value].includes(subOption.value)
                              : false
                        }
                        readonly
                     />
                  </li>
               ))}
            </ul>
         </div>
      </div>
   );
};

export default MobileSubOptionsFilter;
